import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row m-0 w-100 upload-panel v-theme--light" }
const _hoisted_2 = {
  key: 0,
  class: "row m-0 p-0 w-100 requesting"
}
const _hoisted_3 = { class: "d-flex justify-center m-0 text-white" }
const _hoisted_4 = {
  key: 1,
  class: "row m-0 p-0 w-100 requesting"
}
const _hoisted_5 = { class: "d-flex justify-center m-0 text-white" }
const _hoisted_6 = { class: "row m-0 pb-0 notice" }
const _hoisted_7 = {
  key: 2,
  class: "row m-0"
}
const _hoisted_8 = { class: "col-9" }
const _hoisted_9 = {
  key: 3,
  class: "row m-0"
}
const _hoisted_10 = { class: "col-9" }
const _hoisted_11 = { style: {"position":"relative"} }
const _hoisted_12 = { class: "row m-0" }
const _hoisted_13 = { class: "row m-0 pt-0" }
const _hoisted_14 = { class: "col-6" }
const _hoisted_15 = { class: "row m-0 pt-0" }
const _hoisted_16 = { class: "col-9 mb-0" }
const _hoisted_17 = { class: "row m-0 py-0" }
const _hoisted_18 = { class: "row m-0 v-theme--light justify-content-end" }
const _hoisted_19 = {
  key: 0,
  style: {"width":"fit-content"}
}
const _hoisted_20 = {
  key: 1,
  style: {"width":"fit-content"}
}

import "gitart-vue-dialog/dist/style.css";
import VehicleAutoComplete from "@/components/CvrConvert/UploadRequestVehicleAutoComplete.vue";
import SelectTime from "@/components/CvrConvert/SelectTime.vue";
import SelectRangeSelect from "@/components/CvrConvert/SelectRangeSelect.vue";
import CvrConvert from "@/services/models/CvrConvert";
import { GDialog } from "gitart-vue-dialog";
import { Ref, ref, reactive, computed } from "vue";
import { formatDateTime } from "@/services/functions";
import RequestCameraType from "@/components/CvrConvert/RequestCameraType.vue"
import i18n from '@/lang/i18n';
import getVehicleResponse from "@/types/responses/getVehicle"
import LoadingAnimation from "@/components/CvrConvert/LoadingAnimation.vue"
import { CVR_UPLOAD_REQUEST_SELECT_RANGE } from "@/services/consts"
import getVehicleType from "@/types/responses/getVehicle"
import { scrollToErrorComponent } from "@/services/validators"

type errorTypes = {
  start_datetime: string[],
  end_datetime: string[],
  vehicle: string[],
  files: string[],
  types: string[],
}

type formType = {
  start_datetime: string;
  end_datetime: string;
  vehicle: getVehicleType | undefined;
  files: File[];
  types: string[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'UploadRequestPanel',
  props: {
    reload: { type: Function },
    showFlash: { type: Function },
    modelValue: { type: Boolean },
    reading: { type: Boolean },
    ranges: {},
    selectedVehicle: {},
    createAuthority: { type: Boolean }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

let requesting = ref(false);
let showableButtonArea = ref(true);

const getRange = ref(CVR_UPLOAD_REQUEST_SELECT_RANGE[0])
const isDisabledRequestButton: Ref<boolean> = ref(false)
const loading: Ref<boolean> = ref(false);
const isSucceeded: Ref<boolean> = ref(false)

const emits = __emit

const props = __props;

const form = reactive({
  start_datetime: "",
  end_datetime: "",
  vehicle: props.selectedVehicle,
  files: [],
  types: [] as string[]
}) as formType;

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits('update:modelValue', value);
  },
})

const initializeForm = () => {
  form.start_datetime = "";
  form.end_datetime = "";
  form.files = [];
  form.types = [];
  getRange.value = CVR_UPLOAD_REQUEST_SELECT_RANGE[0];
};

const errors = reactive({
  start_datetime: [],
  end_datetime: [],
  vehicle: [],
  files: [],
  types: [],
}) as errorTypes;

const initializeErrors = () => {
  errors.start_datetime = [];
  errors.end_datetime = [];
  errors.vehicle = [];
  errors.files = [];
  errors.types = [];
};

const endDateTime = computed(() => {
  if (!form.start_datetime) return ""
  const selectedPeriod = CVR_UPLOAD_REQUEST_SELECT_RANGE.indexOf(getRange.value) + 1
  const startTime = new Date(form.start_datetime)
  const endTime = new Date(startTime.setMinutes(startTime.getMinutes() + selectedPeriod))
  return formatDateTime(endTime);
})

const selectedPeriod = computed(() => {
  if (!form.start_datetime) return ""
  return `${form.start_datetime} ~ ${endDateTime.value}`
})

const moveFormView = () => {
  if (!validate()) return;
  requesting.value = true;

  CvrConvert.request({
    start_datetime: form.start_datetime,
    end_datetime: endDateTime.value,
    device_id: props.selectedVehicle.digital_tacograph,
    types: form.types,
    files: [],
  })
    .then(() => {
      props.showFlash(i18n.global.t('pages.cvr_uploads.requestPanel.success'), "success", true);
      isSucceeded.value = true
      closeModal()
    })
    .catch((error) => {
      if (error?.response?.data?.errors) {
        setErrors(error.response.data.errors)
      } else {
        closeModal()
        props.showFlash(i18n.global.t('pages.cvr_uploads.requestPanel.failed'), "error", false);
      }
    })
    .finally(() => {
      requesting.value = false;
    });
};

const validate = () => {
  let isValid = true;
  initializeErrors();
  if (!validateStartDateTime()) isValid = false;
  if (!validateVehicle()) isValid = false;

  if (!isValid) scrollToErrorComponent()
  return isValid;
};

const validateVehicle = () => {
  if (!props.selectedVehicle.id) {
    errors.vehicle.push(i18n.global.t('pages.cvr_uploads.errorMessages.notSelect'));
  } else if (!props.selectedVehicle.digital_tacograph) {
    errors.vehicle.push(i18n.global.t('pages.cvr_uploads.errorMessages.hasNoDevice'));
  } else {
    return !errors.vehicle[0];
  }
};

const validateStartDateTime = () => {
  if (!form.start_datetime) {
    errors.start_datetime.push(i18n.global.t('pages.cvr_uploads.errorMessages.notSelectStartDateTime'));
    return false;
  }
  return true;
};

const setErrors = (responseErrors: {[key:string]: string[]}) => {
  errors.start_datetime = responseErrors?.start_datetime ?? [];
  errors.end_datetime = responseErrors?.end_datetime ?? [];
  errors.vehicle = responseErrors?.device_id ?? [];
  errors.types = responseErrors?.types ?? [];
  scrollToErrorComponent()
}

const changeStatusRequestButton = (bool: boolean) => {
  isDisabledRequestButton.value = bool;
}

const closeModal = () => {
  if (isSucceeded.value) props.reload()
  modelValue.value = false
  initializeForm();
  initializeErrors();
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (modelValue.value)
    ? (_openBlock(), _createBlock(_unref(GDialog), {
        key: 0,
        ref: "spot_modal",
        modelValue: modelValue.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((modelValue).value = $event)),
        "max-width": "50%",
        transition: "custom-from-bottom-transition",
        persistent: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_unref(requesting))
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(i18n).global.t('pages.cvr_uploads.requestPanel.requesting')), 1)
                ]))
              : _createCommentVNode("", true),
            (props.reading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(i18n).global.t('pages.cvr_uploads.requestPanel.loading')), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", null, _toDisplayString(_unref(i18n).global.t('pages.cvr_uploads.notice')), 1)
            ]),
            (props.selectedVehicle)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_v_text_field, {
                      label: props.selectedVehicle.number_plate,
                      readonly: "",
                      "error-messages": errors.vehicle
                    }, null, 8, ["label", "error-messages"])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(VehicleAutoComplete, {
                      modelValue: form.vehicle,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.vehicle) = $event)),
                      requestParams: { type: 'filter' },
                      "error-messages": errors.vehicle
                    }, null, 8, ["modelValue", "error-messages"])
                  ])
                ])),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(SelectTime, {
                  label: _unref(i18n).global.t('pages.cvr_uploads.startDateTime'),
                  modelValue: form.start_datetime,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.start_datetime) = $event)),
                  loading: loading.value,
                  reading: props.reading,
                  ranges: props.ranges,
                  errors: errors.start_datetime
                }, null, 8, ["label", "modelValue", "loading", "reading", "ranges", "errors"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(SelectRangeSelect, {
                    ranges: props.ranges,
                    selectedTime: form.start_datetime,
                    modelValue: getRange.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((getRange).value = $event))
                  }, null, 8, ["ranges", "selectedTime", "modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("p", _hoisted_16, _toDisplayString(`${_unref(i18n).global.t('pages.cvr_uploads.selectedPeriod')}: ${selectedPeriod.value}`), 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(RequestCameraType, {
                  modelValue: form.types,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.types) = $event)),
                  reading: props.reading,
                  vehicle: props.selectedVehicle,
                  errors: errors.types,
                  onChangeStatusRequestButton: changeStatusRequestButton
                }, null, 8, ["modelValue", "reading", "vehicle", "errors"])
              ])
            ]),
            _createVNode(LoadingAnimation, { loading: loading.value }, null, 8, ["loading"]),
            _createElementVNode("div", _hoisted_18, [
              (_unref(showableButtonArea))
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createVNode(_component_v_btn, {
                      class: "reset-btn",
                      onClick: closeModal
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(i18n).global.t('common.cancelBtn')), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (_unref(showableButtonArea))
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    (props.createAuthority)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 0,
                          loading: loading.value,
                          disabled: isDisabledRequestButton.value,
                          class: "exec-btn",
                          onClick: moveFormView,
                          style: _normalizeStyle({
                backgroundColor : isDisabledRequestButton.value ? '#B3B8BB' : ''
              })
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.cvr_uploads.requestPanel.requestBtn')), 1)
                          ]),
                          _: 1
                        }, 8, ["loading", "disabled", "style"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]))
    : _createCommentVNode("", true)
}
}

})